
function init() {

    // Carosels
    tnsInstancing();

    // Portfolio Filters
    const portfolio = new portfolioFilter();

    // Lightboxes
    refreshFsLightbox();

    // Iframes
    // deferIframeLoading('iframe', 0);

    // comment form handling
    let commentForm = document.getElementById('commentform');
    commentForm !== null ? commentForm.addEventListener('submit', sendCommentToDB) : null;

    // Phone CTA
    let CTA = new PhoneCTA();

    // generic fade in / out | x.helpers.js
    let fades = document.querySelectorAll('[data-fade]');
    fades.forEach(fade => {
        fade.addEventListener('click', genericFade);
    });

    // Header functions
    let header = new Header();

    // Mask
    var telMask = ['(99) 9999-99999', '(99) 99999-9999'];
    let phones = document.querySelectorAll('.phone-mask')

    if( phones.length > 0 ) {
        phones.forEach(phone => {
            VMasker(phone).maskPattern(telMask[0]);
            phone.addEventListener('input', inputHandler.bind(undefined, telMask, 14), false);
        })
    }

    var dateInputs = document.querySelectorAll('.date-mask')
    if( dateInputs ) {
        dateInputs.forEach(ipt => {
            VMasker(ipt).maskPattern('99/99/9999')
        })
    }

    // Title em todos os itens de menu
    let menu_items = document.querySelectorAll('.menu-item > a')
    if( menu_items ) {
        menu_items.forEach(item => {
            item.setAttribute('title', item.textContent)
        })
    }

    // Envio de forms
    handleForm()
}

// window load binds
window.onload = init;

function DOMLoaded() {
    // these are not always necessary but sometimes they fuck with ya
    if (helpers.iOS) {
        document.querySelector('html').classList.add('ios');
    } else if (helpers.IE()) {
        document.querySelector('html').classList.add('ie');
    }
}

// domcontent binds
document.addEventListener('DOMContentLoaded', DOMLoaded);